import React from 'react';
import { Link } from 'react-router-dom';

const OurAttorneysOne = () => {
    return(
        <>
        {/*Our Attorneys Section*/}
        <section className="our-attorneys-sections section-padding-four">
            <div className="default-container">
            <div className="row clearfix">
                <div className="col-lg-12">
                <div className="sec-o-title text-center pb-3">
                    <h2 className="transform-uppercase">OUR <span>ATTORNEYS</span></h2>
                </div>
                </div>
            </div>
            <div className="row clearfix">
                <div className="col-lg-3 mb-5">
                <div className="attorney-box text-center">
                    <div className="attorney-img">
                    <img src="images/attorneys/at-01-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                    </div>
                    <div className="attorney-social-details">
                    <div className="mt-3">
                        <h6 className="mb-0 font-weight-bold"><Link to="#">Alex Jacobson</Link></h6>
                        <p className="attorney-work">Corporate Lawyer</p>
                    </div>
                    <ul className="list-inline mb-0 text-center">
                        <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                        <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                        <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                        <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                    </ul>
                    </div>
                </div>
                </div>
                <div className="col-lg-3 mb-5">
                <div className="attorney-box text-center">
                    <div className="attorney-img">
                    <img src="images/attorneys/at-02-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                    </div>
                    <div className="attorney-social-details">
                    <div className="mt-3">
                        <h6 className="mb-0 font-weight-bold"><Link to="#">Polard Andrew</Link></h6>
                        <p className="attorney-work">Corporate Lawyer</p>
                    </div>
                    <ul className="list-inline mb-0 text-center">
                        <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                        <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                        <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                        <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                    </ul>
                    </div>
                </div>
                </div>
                <div className="col-lg-3 mb-5">
                <div className="attorney-box text-center">
                    <div className="attorney-img">
                    <img src="images/attorneys/at-03-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                    </div>
                    <div className="attorney-social-details">
                    <div className="mt-3">
                        <h6 className="mb-0 font-weight-bold"><Link to="#">john denver</Link></h6>
                        <p className="attorney-work">Corporate Lawyer</p>
                    </div>
                    <ul className="list-inline mb-0 text-center">
                        <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                        <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                        <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                        <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                    </ul>
                    </div>
                </div>
                </div>
                <div className="col-lg-3 mb-5">
                <div className="attorney-box text-center">
                    <div className="attorney-img">
                    <img src="images/attorneys/at-04-255x330.png" alt="" className="img-fluid mx-auto d-block" />
                    </div>
                    <div className="attorney-social-details">
                    <div className="mt-3">
                        <h6 className="mb-0 font-weight-bold"><Link to="#">ALina Kevin</Link></h6>
                        <p className="attorney-work">Corporate Lawyer</p>
                    </div>
                    <ul className="list-inline mb-0 text-center">
                        <li className="list-inline-item"><Link to="#" className><i className="fa fa-facebook" /></Link></li>
                        <li className="list-inline-item"><Link to="#" className><i className="fa fa-instagram" /></Link></li>
                        <li className="list-inline-item"><Link to="#"><i className="fa fa-pinterest-p" /></Link></li>
                        <li className="list-inline-item"><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                    </ul>
                    </div>
                </div>
                </div>
            </div>
            <div className="row clearfix">
                <div className="col-lg-12">
                <div className="button-box text-center">
                    <Link to="#" className="o-btn btn-style-one">Load More</Link>
                </div>
                </div>
            </div>
            </div>
        </section>
        {/* End Our Attorneys Section */}
        </>
    )
}

export default OurAttorneysOne;